<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
              <card-section-header
                title="Site Procedures"
                icon="fas fa-list"
                buttonLabel="CREATE PROCEDURE"
                buttonIcon="fas fa-plus"
                (buttonClick)="showCreateProcedureModal()">
            </card-section-header>
            <div class="procedure-tabs-header">
              <ul class="nav nav-tabs procedure-tabs">
                <li class="nav-item">
                  <a [class]="isOEMView == false ? 'nav-link active' : 'nav-link'" (click)="toggleSiteOemView(false)">
                    <span>Site Procedures</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a [class]="isOEMView == true ? 'nav-link active' : 'nav-link'" (click)="toggleSiteOemView(true)">
                    <span>OEM Procedures</span>
                  </a>
                </li>
              </ul>
            </div>
            <div *ngIf="!isOEMView" [class]="isOEMView == false ? 'fade show active' : 'fade'">
            <div class="mb-2 animated fadeIn">
              <div class="row">
                <div class="col-md-12">
                  <div class="filter-flex-row">
                    <div>
                      <label>ID</label>
                      <text-filter-box
                        #siteIdFilter
                        placeholder="Filter by ID..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'idFilter')">
                      </text-filter-box>
                    </div>
                    <div>
                      <label>Name/Code</label>
                      <text-filter-box
                        #siteNameFilter
                        placeholder="Filter by name/code..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'nameFilter')">
                      </text-filter-box>
                    </div>
                    <div>
                      <label>Description</label>
                      <text-filter-box
                        #siteDescriptionFilter
                        placeholder="Filter by description..."
                        (onFilterTextChanged)="onFilterTextChanged($event, 'descriptionFilter')">
                      </text-filter-box>
                    </div>
                    <div *ngIf="isFilterLoading" class="small-spinner">
                      <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                    </div>
                  </div>
                  <br>
                </div>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table
                      [resizableColumns]="true"
                      [autoLayout]="true"
                      [value]="procedures"
                      (onSort)="customSort($event)"
                      [sortField]="defaultSortField"
                      [lazy]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th [pSortableColumn]="'id'">ID
                          <p-sortIcon [field]="'id'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'name'">Name/Code
                          <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'description'">Description
                          <p-sortIcon [field]="'description'"></p-sortIcon>
                        </th>
                        <th>Revision</th>
                        <th>Minimum Work Party Size</th>
                        <th [pSortableColumn]="'assetCategory.name'">Asset Category
                          <p-sortIcon [field]="'assetCategory.name'"></p-sortIcon>
                        </th>
                        <th>Competencies</th>
                        <th>Created By</th>
                        <th [pSortableColumn]="'lastModifiedDate'">Last Updated
                          <p-sortIcon [field]="'lastModifiedDate'"></p-sortIcon>
                        </th>
                        <th>Pre-approved</th>
                        <th *ngIf="allowCompulsoryCheckOnSiteForm">Check-On Site Form</th>
                        <th *ngIf="allowCompulsoryCheckOffSiteForm">Check-Off Site Form</th>
                        <th>Actions</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-procedure>
                      <tr class="procedure-row-clickable" (click)="viewProcedure(procedure)">
                        <td>PRC{{ procedure.id }}</td>
                        <td>{{ procedure.name }}</td>
                        <td>{{ procedure.description }}</td>
                        <td>{{ procedure.revision }}</td>
                        <td>{{ procedure.minimumPartySize }}</td>
                        <td>{{ procedure.assetCategory.name }}</td>
                        <td>
                          <div class="competency-overview-cell" *ngIf="procedure.detailedCompetencies && procedure.detailedCompetencies.length">
                            <div *ngFor="let competency of procedure.detailedCompetencies" class="competency-overview-item">
                              <span class="competency-overview-badge" [attr.style]="'background-color: ' + (competency.name | competencyBadgeColor) | safestyle">
                                {{ competency.name }}
                              </span>
                              <span class="competency-overview-details" *ngIf="hasCompetencyDetails(competency)">
                                {{ competency.oem }}
                                <span *ngIf="competency.model"> | {{ competency.model }}</span>
                                <span *ngIf="competency.rating"> | {{ competency.rating }}</span>
                                |
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>{{ procedure.createdBy }}</td>
                        <td>{{ procedure.lastModifiedDate | date: 'E d MMM yyyy HH:mm' }}</td>
                        <td class="table-cell-centered">
                          <span *ngIf="procedure.preapproved === true"><i class="fas fa-check-circle success"></i></span>
                          <span *ngIf="procedure.preapproved === false"><i class="fas fa-times-circle danger"></i></span>
                        </td>
                        <td *ngIf="allowCompulsoryCheckOnSiteForm">{{ procedure.checkOnSiteFormName }}</td>
                        <td *ngIf="allowCompulsoryCheckOffSiteForm">{{ procedure.checkOffSiteFormName }}</td>
                        <td class="table-cell-centered">
                          <button
                            type="button"
                            class="btn btn-primary btn-link procedure-view-button"
                            (click)="viewProcedure(procedure); $event.stopPropagation()">
                            <i class="fa fa-search"></i>
                            View
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="allowCompulsoryCheckOnSiteForm && allowCompulsoryCheckOffSiteForm ? 13 : (allowCompulsoryCheckOnSiteForm || allowCompulsoryCheckOffSiteForm ? 12 : 11)">No procedures found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
            </div>
            <div *ngIf="isOEMView && selectedSite" [class]="isOEMView == true ? 'fade show active' : 'fade'">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">OEM Procedure Settings</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <dl class="sideways-dl">
                        <div>
                          <dt>Minimum Work Party Size</dt>
                          <dd>{{ selectedSite.oemProcedureMinimumPartySize }}</dd>
                        </div>
                        <div>
                          <dt>Preapproved</dt>
                          <dd>
                            <span *ngIf="selectedSite.oemProcedurePreapproved === true"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="selectedSite.oemProcedurePreapproved === false"><i class="fas fa-times-circle danger"></i></span>
                          </dd>
                        </div>
                        <div *ngIf="allowCompulsoryCheckOnSiteForm">
                          <dt>Check On Site Form</dt>
                          <dd *ngIf="selectedSite.oemProcedureCheckOnSiteForm">{{ selectedSite.oemProcedureCheckOnSiteForm.name }}</dd>
                          <dd *ngIf="!selectedSite.oemProcedureCheckOnSiteForm">None Selected</dd>
                        </div>
                        <div *ngIf="allowCompulsoryCheckOffSiteForm">
                          <dt>Check Off Site Form</dt>
                          <dd *ngIf="selectedSite.oemProcedureCheckOffSiteForm">{{ selectedSite.oemProcedureCheckOffSiteForm.name }}</dd>
                          <dd *ngIf="!selectedSite.oemProcedureCheckOffSiteForm">None Selected</dd>
                        </div>
                      </dl>
                      <button type="button" (click)="showOEMSettingsModal()" class="my-2 btn btn-round btn-sm color_blue-btn">Change</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="competency-section-header">
                    <h4 class="card-title">OEM Procedure Competencies</h4>
                    <div class="button-link-wrapper">
                      <button type="button" class="btn btn-primary btn-link" (click)="onAddOemProcedureCompetency()">
                        <span><i class="fas fa-plus"></i></span> Add Competency
                      </button>
                    </div>
                  </div>
                  <div class="competency-card-grid" *ngIf="oemProcedureCompetencyCards.length; else noOemProcedureCompetencies">
                    <competency-card
                      *ngFor="let competency of oemProcedureCompetencyCards"
                      [competency]="competency"
                      cardType="work-order-edit"
                      (delete)="onOemProcedureCompetencyDelete($event)">
                    </competency-card>
                  </div>
                  <ng-template #noOemProcedureCompetencies>
                    <p class="procedure-empty-state">No OEM procedure competencies have been added for this site.</p>
                  </ng-template>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <h4 class="card-title">OEM Relationships</h4>
                  <p-table [resizableColumns]="true" [autoLayout]="true" [value]="oems" [lazy]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Added to site</th>
                        <th>OEM Name</th>
                        <th class="table-cell-centered">Number of procedures</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-oem>
                      <tr [pSelectableRow]="oem">
                        <td><input type="checkbox" [checked]="oem.oemForSite" (click)="handleOemForSiteClick($event, oem)" /></td>
                        <td>{{ oem.oemName }}</td>
                        <td class="table-cell-centered">{{ oem.procedureCount }}</td>
                        <td>
                          <button type="button" class="btn btn-primary btn-link" [disabled]="oem.procedureCount < 1" (click)="openOemProceduresModal(oem)">view</button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="4">No OEMs found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                  <br>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view documents -->
<p-dialog header="Procedure Documents" [(visible)]="isViewProcedureDocumentsModalShown" modal="true" [dismissableMask]="true" [baseZIndex]="1000000">
  <div *ngIf="selectedProcedure?.files.length">
    <div class="row" *ngFor="let file of selectedProcedure?.files">
      <div class="col-md-12">
        <button class="btn btn-primary" (click)="viewDocument(file.fileName)">View {{ file.fileName }}</button>
        <button class="btn btn-danger" *ngIf="selectedProcedure.site" (click)="deleteDocument(file.id)">Delete {{ file.fileName }}</button>
      </div>
    </div>
  </div>
  <div *ngIf="!selectedProcedure?.files.length">
    <p>No documents attached to this procedure</p>
  </div>
</p-dialog>

<!-- Upload Additional Documents Files Dialog -->
<p-dialog [(visible)]="isAddDocumentsToProcedureModalShown">
  <p-header> Upload Procedure RAMS Files </p-header>
  <div *ngIf="!saveInProgress" class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="procedureDocuments" class="btn btn-primary btn-round">Choose Documents...</label>
        <input
          type="file"
          class="form-control"
          name="procedureDocuments"
          id="procedureDocuments"
          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
          (change)="onFileChange($event)"
          multiple/>
        <ng-container *ngIf="selectedDocuments.length">
          <p>Selected Files:</p>
          <ul>
            <li *ngFor="let file of selectedDocuments">{{ file.name }}</li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" class="btn btn-default-outline" (click)="isAddDocumentsToProcedureModalShown = false">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="saveInProgress" (click)="onAddDocumentsSubmit()">Upload</button>
  </p-footer>
</p-dialog>


<p-dialog *ngIf="selectedOem" [(visible)]="showOEMProceduresModal" modal="true" [baseZIndex]="1000000">
  <p-header>{{ selectedOem.oemName }} OEM Procedures </p-header>
  <div class="row">
    <div class="col-md-12">
      <div class="filter-flex-row">
        <div>
          <label>ID</label>
          <text-filter-box
            #oemIdFilter
            placeholder="Filter by ID..."
            (onFilterTextChanged)="onFilterTextChanged($event, 'idFilter')">
          </text-filter-box>
        </div>
        <div>
          <label>Name/Code</label>
          <text-filter-box
            #oemNameFilter
            placeholder="Filter by name/code..."
            (onFilterTextChanged)="onFilterTextChanged($event, 'nameFilter')">
          </text-filter-box>
        </div>
        <div>
          <label>Description</label>
          <text-filter-box
            #oemDescriptionFilter
            placeholder="Filter by description..."
            (onFilterTextChanged)="onFilterTextChanged($event, 'descriptionFilter')">
          </text-filter-box>
        </div>
        <div *ngIf="isFilterLoading" class="small-spinner">
          <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
        </div>
      </div>
      <br>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <p-table
          [resizableColumns]="true"
          [autoLayout]="true"
          [value]="oemProcedures"
          (onSort)="customSort($event)"
          [sortField]="defaultSortField"
          [lazy]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'id'">ID
              <p-sortIcon [field]="'id'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'name'">Name/Code
              <p-sortIcon [field]="'name'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'description'">Description
              <p-sortIcon [field]="'description'"></p-sortIcon>
            </th>
            <th>Revision</th>
            <th [pSortableColumn]="'assetCategory.name'">Asset Category
              <p-sortIcon [field]="'assetCategory.name'"></p-sortIcon>
            </th>
            <th>Attached Docs</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-procedure>
          <tr [pSelectableRow]="procedure">
            <td>PRC{{ procedure.id }}</td>
            <td>{{ procedure.name }}</td>
            <td>{{ procedure.description }}</td>
            <td>{{ procedure.revision }}</td>
            <td>{{ procedure.assetCategory.name }}</td>
            <td>
              <ng-container *ngIf="!procedure.files.length; else showFiles">&nbsp;&nbsp;0</ng-container>
              <ng-template #showFiles>
                <button type="button" class="btn btn-primary btn-link" (click)="showViewDocumentsModal(procedure)">{{ procedure.files.length }}</button>
              </ng-template>
            </td>
            <td><button type="button" class="btn btn-primary btn-link" (click)="showCreateWorkOrderModalForOemProcedure(procedure)">create work order</button></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="7">No procedures found</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="card-footer">
        <p-paginator
          #paginator
          [rows]="pagination.size"
          [totalRecords]="pagination.totalRecords"
          [rowsPerPageOptions]="pageSizes"
          (onPageChange)="paginate($event)">
        </p-paginator>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog *ngIf="selectedSite" [(visible)]="showOEMProcedureSettingsModal" modal="true" [baseZIndex]="1000000">
  <p-header>{{ selectedSite.name }} OEM Procedure Settings </p-header>
  <form *ngIf="!saveInProgress" [formGroup]="updateSiteOEMSettingsForm" (ngSubmit)="submitOemProcedureSettings()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Minimum Work Party Size <span class="required-star">*</span></label>
          <input type="number" value=1 class="form-control" formControlName="minPartySize" min="1" max="30">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label for="preapproved">Pre-approved?</label>
          <p-checkbox class="form-control" inputId="preapproved" formControlName="preapproved" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" *ngIf="siteFormsOptions.length && allowCompulsoryCheckOnSiteForm">
        <div class="form-group">
          <label>Select Compulsory Check-On Site Form</label>
          <p-dropdown
            class="form-control"
            formControlName="siteFormCheckOn"
            [options]="siteFormsOptions"
            placeholder="Select Site Form..."
            required="false"
            [style]="{ width: '100%' }"
            filter="true">
          </p-dropdown>
        </div>
      </div>
      <div class="col-md-6" *ngIf="siteFormsOptions.length && allowCompulsoryCheckOffSiteForm ">
        <div class="form-group">
          <label>Select Compulsory Check-Off Site Form</label>
          <p-dropdown
            class="form-control"
            formControlName="siteFormCheckOff"
            [options]="siteFormsOptions"
            placeholder="Select Site Form..."
            required="false"
            [style]="{ width: '100%' }"
            filter="true">
          </p-dropdown>
        </div>
      </div>
    </div>
    <button type="button" (click)="submitOemProcedureSettings()" class="my-2 btn btn-round btn-sm btn-success">Save</button>

  </form>
</p-dialog>
